import { elk } from './index';
import { isFunction } from './type';

/**
 * log(action,error);
 * log(error);
 * @param config
 */
const log = {}
log.init = function (callback) {
  let _onError = () => {
  };
  if (isFunction(window.onerror)) {
    _onError = window.onerror;
  }
  window.onerror = function (...args) {
    _onError(...args);
    const [msg, url, line, column, error] = args;
    elk({
      msg,
      str1: error && error.stack,
      str2: url,
      str3: line,
      key: 'JS_ERROR',
      str4: column
    });
    typeof callback === 'function' && callback(...args);
  }
};

log.use = function (f, callback) {
  // 用于vue内的错误异常捕获
  f.errorHandler = function (error) {
    elk({
      msg: error,
      str1: error && error.stack,
      key: 'JS_ERROR'
    });
    callback && callback(error);
  }
}

export default log;